import { render, staticRenderFns } from "./newMapRouter.vue?vue&type=template&id=52b99836&scoped=true"
import script from "./newMapRouter.vue?vue&type=script&lang=js"
export * from "./newMapRouter.vue?vue&type=script&lang=js"
import style0 from "./newMapRouter.vue?vue&type=style&index=0&id=52b99836&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b99836",
  null
  
)

export default component.exports